import Vue from 'vue'

import Router from 'vue-router'

import store from '@/store'

import Logs from '../components/logs/Logs'
import Login from '../components/authentication/Login'
import LoginTenant from '../components/authentication/LoginTenant'
import LoginTenantSelection from '../components/authentication/LoginTenantSelection'
import Logout from '../components/authentication/Logout'
import Index from '../components/Index'
import Evaluation from '../components/evaluation/Evaluation'
import ManageEmployees from '../components/ManageEmployees'
import ManageOperations from '../components/ManageOperations'
import ManageProjects from '../components/ManageProjects'
import Settings from '../components/Settings'
// import Table from '../components/evaluation/Table'

Vue.use(Router)

const router = new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        noLoginRequired: true
      }
    },
    {
      path: '/login/tenant',
      name: 'login-tenant-selection',
      component: LoginTenantSelection,
      meta: {
        noLoginRequired: true
      }
    },
    {
      path: '/login/tenant/:loginIdentifier',
      name: 'login-tenant',
      props: true,
      component: LoginTenant,
      meta: {
        noLoginRequired: true
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      meta: {
        noLoginRequired: true
      }
    },
    {
      path: '/logs',
      name: 'logs',
      component: Logs
    },
    {
      path: '/evaluation',
      name: 'evaluation',
      component: Evaluation
    },
    {
      path: '/employees/:id?',
      name: 'employees',
      component: ManageEmployees,
      meta: {
        admin: true
      }
    },
    {
      path: '/projects/:id?',
      name: 'projects',
      component: ManageProjects,
      meta: {
        admin: true
      }
    },
    {
      path: '/operations/:id?',
      name: 'operations',
      component: ManageOperations,
      meta: {
        admin: true
      }
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    // {
    //   path: '/table',
    //   name: 'table',
    //   component: Table
    // }
  ]
})

router.beforeEach(async function (to, from, next) {
  // Dispatch existing Alerts from State
  store.dispatch('clearAlerts')
  // Check if route is available without login
  if (to.meta.noLoginRequired) {
    next()
    return
  }
  await store.getters.loginProbePromise
  if (store.getters.isLoggedIn) {
    next()
  } else {
    next({
      name: 'login',
      query: {
        next: to.path
      }
    })
  }
})

export default router
